import { render, staticRenderFns } from "./PeppolEndpointInput.vue?vue&type=template&id=585af494&scoped=true"
import script from "./PeppolEndpointInput.vue?vue&type=script&lang=ts"
export * from "./PeppolEndpointInput.vue?vue&type=script&lang=ts"
import style0 from "./PeppolEndpointInput.vue?vue&type=style&index=0&id=585af494&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585af494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585af494')) {
      api.createRecord('585af494', component.options)
    } else {
      api.reload('585af494', component.options)
    }
    module.hot.accept("./PeppolEndpointInput.vue?vue&type=template&id=585af494&scoped=true", function () {
      api.rerender('585af494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/peppol/PeppolEndpointInput.vue"
export default component.exports